import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M12.57 10.133s-15.14 4.356-8.918 18.46c-1.452-5.808 1.037-7.26 5.392-8.09.208 0 3.526-10.37 3.526-10.37M9.666 24.237S21.074 35.022 30.2 22.785c-4.148 4.148-6.845 2.904-9.541-.622-.207 0-10.993 2.074-10.993 2.074M23.77 19.467s3.733-15.141-11.615-16.8c5.808 1.451 5.808 4.563 4.148 8.71-.207-.207 7.467 8.09 7.467 8.09" }, null, -1),
    _createElementVNode("path", { d: "M14.644 9.511c4.563-.415 8.919 3.111 9.333 7.674.415 4.563-3.11 8.919-7.674 9.334-4.562.414-8.918-3.112-9.333-7.675-.622-4.77 2.696-8.71 7.674-9.333m.83 11.2c1.452-.207 2.696-1.452 2.489-2.904s-1.452-2.696-2.904-2.488c-1.244 0-2.489 1.244-2.489 2.903.207 1.452 1.66 2.49 2.904 2.49" }, null, -1)
  ])))
}
export default { render: render }